import { render } from "./Checkbox.vue?vue&type=template&id=3f4a8d8e"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"
script.render = render

export default script